var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _path65, _path66, _path67, _path68, _path69, _path70, _path71, _path72, _path73, _path74, _path75, _path76, _path77, _path78, _path79, _path80, _path81, _path82, _path83, _path84, _path85, _path86, _path87, _path88, _path89, _path90, _path91, _path92, _path93, _path94, _path95, _path96, _path97, _path98, _path99, _path100, _path101, _path102, _path103, _path104, _path105, _path106, _path107, _g, _path108, _g2, _path109, _g3, _path110, _g4, _path111, _g5, _path112, _g6, _path113, _g7, _path114, _g8, _path115, _g9, _path116, _g10, _path117, _g11, _path118, _g12, _path119, _path120, _path121, _path122, _path123, _path124, _path125, _path126, _path127, _path128, _path129, _path130, _path131, _path132, _path133, _path134, _path135, _path136, _path137, _path138, _path139, _path140, _path141, _path142, _path143, _path144, _path145, _path146, _path147, _path148, _path149, _path150, _path151, _path152, _path153, _path154, _path155, _path156, _path157, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIoTbanner2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 568,
    height: 598,
    viewBox: "0 0 568 598",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M244.29 499.223C246.599 500.604 246.611 502.829 244.316 504.21L191.452 536.049C189.157 537.43 185.442 537.437 183.133 536.056L100.888 486.845C98.5789 485.464 98.5674 483.227 100.86 481.845L153.725 450.005C156.018 448.624 159.734 448.629 162.044 450.012L244.29 499.223Z",
    fill: "#FE9BA8"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M239.137 501.147C239.472 501.347 239.654 501.636 239.585 501.938C239.468 502.452 238.683 502.817 237.826 502.745L166.348 496.909C165.998 496.878 165.679 496.784 165.44 496.639C165.209 496.501 165.05 496.309 164.999 496.101L155.125 453.594C155.003 453.08 155.608 452.607 156.464 452.535C156.967 452.493 157.446 452.602 157.78 452.802C158.016 452.943 158.181 453.129 158.232 453.343L167.932 495.138L238.234 500.879C238.589 500.908 238.902 501.006 239.137 501.147Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M278.317 559.256C280.626 560.637 280.638 562.862 278.343 564.243L225.479 596.081C223.184 597.462 219.47 597.468 217.16 596.087L134.915 546.876C132.606 545.495 132.595 543.259 134.889 541.876L187.754 510.038C190.047 508.657 193.763 508.662 196.072 510.045L278.317 559.256Z",
    fill: "#FE7386"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M273.162 561.18C273.497 561.38 273.68 561.669 273.61 561.971C273.493 562.485 272.708 562.85 271.851 562.778L200.373 556.942C200.024 556.911 199.704 556.817 199.463 556.672C199.233 556.533 199.073 556.342 199.022 556.134L189.148 513.627C189.027 513.113 189.631 512.64 190.488 512.568C190.99 512.526 191.469 512.635 191.804 512.835C192.039 512.976 192.204 513.162 192.255 513.376L201.956 555.171L272.258 560.912C272.615 560.941 272.927 561.039 273.162 561.18Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M76.7847 236.004C79.4417 234.414 82.1019 234.03 84.1363 235.23C88.2016 237.631 88.223 245.461 84.184 252.716C82.1629 256.342 79.5092 259.139 76.8522 260.728C74.1952 262.317 71.5349 262.701 69.5006 261.501C65.4352 259.096 65.4138 251.267 69.4528 244.015C71.4756 240.389 74.1293 237.593 76.7847 236.004Z",
    fill: "#FE7386"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M76.7204 212.746C86.6565 206.8 96.6042 205.359 104.193 209.837L95.288 225.821C90.1701 222.799 83.4609 223.77 76.76 227.78C70.059 231.79 63.3663 238.836 58.2829 247.964L49.3203 242.67C56.8597 229.139 66.7843 218.692 76.7204 212.746Z",
    fill: "#FE7386"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M76.6632 191.258C91.8606 182.165 106.155 180.655 116.91 187.008L108.007 202.991C99.6471 198.049 88.5266 199.231 76.7044 206.305C64.8822 213.379 53.793 225.485 45.486 240.4L36.5234 235.108C47.2107 215.926 61.4659 200.352 76.6632 191.258Z",
    fill: "#FE7386"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M76.6032 169.779C96.6286 157.797 115.458 155.813 129.628 164.182L120.723 180.16C108.948 173.205 93.2929 174.863 76.6427 184.826C59.9925 194.789 44.38 211.841 32.6814 232.84L23.7188 227.547C37.7993 202.279 56.5794 181.762 76.6032 169.779Z",
    fill: "#FE7386"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M138.307 173.796L172.473 195.565L154.122 206.545L154.498 344.011L123.099 362.798L122.723 225.334L104.371 236.312L138.307 173.796Z",
    fill: "#C1E2F5"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M76.5963 278.148L98.6181 292.179L86.7877 299.259L87.0299 387.864L66.7952 399.97L66.5531 311.366L54.7227 318.443L76.5963 278.148Z",
    fill: "#FE7386"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M314.969 331.321C316.697 330.286 318.1 331.111 318.105 333.168C318.11 335.221 316.716 337.724 314.988 338.758C313.265 339.79 311.862 338.96 311.855 336.908C311.851 334.851 313.246 332.352 314.969 331.321Z",
    fill: "url(#paint0_linear_437_4322)"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M314.969 314.352C316.697 313.318 318.1 314.142 318.105 316.201C318.11 318.253 316.716 320.757 314.988 321.792C313.265 322.823 311.862 321.993 311.855 319.941C311.851 317.882 313.246 315.383 314.969 314.352Z",
    fill: "url(#paint1_linear_437_4322)"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M314.969 297.385C316.697 296.35 318.1 297.175 318.105 299.232C318.11 301.286 316.716 303.788 314.988 304.823C313.265 305.854 311.862 305.024 311.855 302.972C311.851 300.915 313.246 298.416 314.969 297.385Z",
    fill: "url(#paint2_linear_437_4322)"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M314.969 280.415C316.697 279.381 318.1 280.206 318.105 282.264C318.11 284.316 316.716 286.821 314.988 287.855C313.265 288.886 311.862 288.057 311.855 286.005C311.851 283.946 313.246 281.447 314.969 280.415Z",
    fill: "url(#paint3_linear_437_4322)"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M314.969 263.449C316.697 262.414 318.1 263.239 318.105 265.296C318.11 267.35 316.716 269.852 314.988 270.887C313.265 271.918 311.862 271.088 311.855 269.036C311.851 266.977 313.246 264.48 314.969 263.449Z",
    fill: "url(#paint4_linear_437_4322)"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M314.969 246.48C316.697 245.447 318.1 246.27 318.105 248.329C318.11 250.381 316.716 252.885 314.988 253.92C313.265 254.951 311.862 254.121 311.855 252.069C311.851 250.01 313.246 247.511 314.969 246.48Z",
    fill: "url(#paint5_linear_437_4322)"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M314.969 229.513C316.697 228.48 318.1 229.303 318.105 231.362C318.11 233.414 316.716 235.918 314.988 236.953C313.265 237.984 311.862 237.154 311.855 235.102C311.851 233.043 313.246 230.544 314.969 229.513Z",
    fill: "url(#paint6_linear_437_4322)"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M314.969 212.544C316.697 211.511 318.1 212.334 318.105 214.393C318.11 216.445 316.716 218.949 314.988 219.982C313.265 221.013 311.862 220.183 311.855 218.131C311.851 216.074 313.246 213.575 314.969 212.544Z",
    fill: "url(#paint7_linear_437_4322)"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M314.969 195.577C316.697 194.544 318.1 195.367 318.105 197.426C318.11 199.478 316.716 201.982 314.988 203.015C313.265 204.046 311.862 203.216 311.855 201.165C311.851 199.107 313.246 196.608 314.969 195.577Z",
    fill: "url(#paint8_linear_437_4322)"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M314.969 178.608C316.697 177.574 318.1 178.398 318.105 180.457C318.11 182.509 316.716 185.014 314.988 186.046C313.265 187.077 311.862 186.248 311.855 184.196C311.851 182.139 313.246 179.639 314.969 178.608Z",
    fill: "url(#paint9_linear_437_4322)"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M314.969 161.641C316.697 160.607 318.1 161.431 318.105 163.49C318.11 165.542 316.716 168.046 314.988 169.079C313.265 170.11 311.862 169.28 311.855 167.228C311.851 165.171 313.246 162.672 314.969 161.641Z",
    fill: "url(#paint10_linear_437_4322)"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M314.969 144.672C316.697 143.638 318.1 144.462 318.105 146.521C318.11 148.573 316.716 151.077 314.988 152.11C313.265 153.141 311.862 152.312 311.855 150.26C311.851 148.203 313.246 145.703 314.969 144.672Z",
    fill: "url(#paint11_linear_437_4322)"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M314.969 127.705C316.697 126.671 318.1 127.495 318.105 129.552C318.11 131.606 316.716 134.109 314.988 135.143C313.265 136.174 311.862 135.344 311.855 133.292C311.851 131.235 313.246 128.736 314.969 127.705Z",
    fill: "url(#paint12_linear_437_4322)"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M314.969 110.736C316.697 109.702 318.1 110.526 318.105 112.583C318.11 114.635 316.716 117.14 314.988 118.174C313.265 119.205 311.862 118.376 311.855 116.324C311.851 114.267 313.246 111.767 314.969 110.736Z",
    fill: "url(#paint13_linear_437_4322)"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M314.969 93.7691C316.697 92.7345 318.1 93.5591 318.105 95.6162C318.11 97.6681 316.716 100.172 314.988 101.207C313.265 102.238 311.862 101.408 311.855 99.3565C311.851 97.2994 313.246 94.8002 314.969 93.7691Z",
    fill: "url(#paint14_linear_437_4322)"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M314.969 76.8006C316.697 75.766 318.1 76.5906 318.105 78.6477C318.11 80.6996 316.716 83.204 314.988 84.2385C313.265 85.2696 311.862 84.4399 311.855 82.388C311.851 80.3309 313.246 77.8317 314.969 76.8006Z",
    fill: "url(#paint15_linear_437_4322)"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M294.527 254.965C296.255 253.93 297.659 254.755 297.664 256.812C297.669 258.864 296.275 261.368 294.547 262.403C292.824 263.434 291.419 262.604 291.414 260.552C291.409 258.495 292.804 255.996 294.527 254.965Z",
    fill: "url(#paint16_linear_437_4322)"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M294.527 237.996C296.255 236.962 297.659 237.786 297.664 239.845C297.669 241.897 296.275 244.401 294.547 245.436C292.824 246.467 291.419 245.637 291.414 243.585C291.409 241.526 292.804 239.029 294.527 237.996Z",
    fill: "url(#paint17_linear_437_4322)"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M294.527 221.029C296.255 219.994 297.659 220.819 297.664 222.877C297.669 224.929 296.275 227.434 294.547 228.468C292.824 229.499 291.419 228.67 291.414 226.618C291.409 224.559 292.804 222.06 294.527 221.029Z",
    fill: "url(#paint18_linear_437_4322)"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M294.527 204.06C296.255 203.026 297.659 203.85 297.664 205.909C297.669 207.961 296.275 210.465 294.547 211.5C292.824 212.531 291.419 211.701 291.414 209.649C291.409 207.59 292.804 205.093 294.527 204.06Z",
    fill: "url(#paint19_linear_437_4322)"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M294.527 187.093C296.255 186.058 297.659 186.883 297.664 188.942C297.669 190.994 296.275 193.498 294.547 194.532C292.824 195.563 291.419 194.734 291.414 192.682C291.409 190.623 292.804 188.124 294.527 187.093Z",
    fill: "url(#paint20_linear_437_4322)"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M294.527 170.124C296.255 169.09 297.659 169.914 297.664 171.973C297.669 174.025 296.275 176.529 294.547 177.564C292.824 178.595 291.419 177.765 291.414 175.713C291.409 173.655 292.804 171.157 294.527 170.124Z",
    fill: "url(#paint21_linear_437_4322)"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M294.527 153.157C296.255 152.124 297.659 152.947 297.664 155.006C297.669 157.058 296.275 159.562 294.547 160.597C292.824 161.628 291.419 160.798 291.414 158.746C291.409 156.688 292.804 154.188 294.527 153.157Z",
    fill: "url(#paint22_linear_437_4322)"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M294.527 136.188C296.255 135.155 297.659 135.978 297.664 138.037C297.669 140.089 296.275 142.593 294.547 143.628C292.824 144.659 291.419 143.829 291.414 141.777C291.409 139.719 292.804 137.221 294.527 136.188Z",
    fill: "url(#paint23_linear_437_4322)"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M294.527 119.221C296.255 118.188 297.659 119.011 297.664 121.07C297.669 123.122 296.275 125.626 294.547 126.661C292.824 127.692 291.419 126.862 291.414 124.81C291.409 122.751 292.804 120.252 294.527 119.221Z",
    fill: "url(#paint24_linear_437_4322)"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M294.527 102.254C296.255 101.221 297.659 102.044 297.664 104.103C297.669 106.155 296.275 108.659 294.547 109.694C292.824 110.725 291.419 109.895 291.414 107.843C291.409 105.783 292.804 103.285 294.527 102.254Z",
    fill: "url(#paint25_linear_437_4322)"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M294.527 85.2849C296.255 84.2504 297.659 85.0749 297.664 87.1337C297.669 89.1857 296.275 91.69 294.547 92.7245C292.824 93.7556 291.419 92.926 291.414 90.874C291.409 88.8152 292.804 86.316 294.527 85.2849Z",
    fill: "url(#paint26_linear_437_4322)"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M294.527 68.3181C296.255 67.2836 297.659 68.1081 297.664 70.1669C297.669 72.2189 296.275 74.7232 294.547 75.7577C292.824 76.7888 291.419 75.9592 291.414 73.9072C291.409 71.8467 292.804 69.3492 294.527 68.3181Z",
    fill: "url(#paint27_linear_437_4322)"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M294.527 51.3496C296.255 50.3151 297.659 51.1396 297.664 53.1984C297.669 55.2503 296.275 57.7547 294.547 58.7892C292.824 59.8203 291.419 58.9907 291.414 56.9387C291.409 54.8799 292.804 52.3807 294.527 51.3496Z",
    fill: "url(#paint28_linear_437_4322)"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M294.527 34.3821C296.255 33.3475 297.659 34.1721 297.664 36.2309C297.669 38.2828 296.275 40.7872 294.547 41.82C292.824 42.8511 291.419 42.0214 291.414 39.9695C291.409 37.9107 292.804 35.4132 294.527 34.3821Z",
    fill: "url(#paint29_linear_437_4322)"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M294.527 17.4135C296.255 16.379 297.659 17.2036 297.664 19.2624C297.669 21.3143 296.275 23.8187 294.547 24.8515C292.824 25.8826 291.419 25.0529 291.414 23.001C291.409 20.9439 292.804 18.4446 294.527 17.4135Z",
    fill: "url(#paint30_linear_437_4322)"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M294.527 0.446305C296.255 -0.588211 297.659 0.23633 297.664 2.29341C297.669 4.34708 296.275 6.84973 294.547 7.88424C292.824 8.91535 291.419 8.08568 291.414 6.03372C291.409 3.97493 292.804 1.47741 294.527 0.446305Z",
    fill: "url(#paint31_linear_437_4322)"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M27.2723 412.194C28.8108 411.274 30.0611 412.008 30.0661 413.84C30.071 415.668 28.8289 417.898 27.2904 418.82C25.7552 419.738 24.505 418.999 24.5 417.171C24.4951 415.339 25.7371 413.113 27.2723 412.194Z",
    fill: "url(#paint32_linear_437_4322)"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M27.2723 397.081C28.8108 396.16 30.0611 396.895 30.0661 398.726C30.071 400.555 28.8289 402.784 27.2904 403.706C25.7552 404.624 24.505 403.885 24.5 402.057C24.4951 400.225 25.7371 397.999 27.2723 397.081Z",
    fill: "url(#paint33_linear_437_4322)"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M27.2723 381.968C28.8108 381.047 30.0611 381.781 30.0661 383.613C30.071 385.442 28.8289 387.671 27.2904 388.593C25.7552 389.511 24.505 388.772 24.5 386.944C24.4951 385.112 25.7371 382.886 27.2723 381.968Z",
    fill: "url(#paint34_linear_437_4322)"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M27.2723 366.855C28.8108 365.935 30.0611 366.669 30.0661 368.5C30.071 370.329 28.8289 372.558 27.2904 373.48C25.7552 374.399 24.505 373.659 24.5 371.831C24.4951 369.999 25.7371 367.773 27.2723 366.855Z",
    fill: "url(#paint35_linear_437_4322)"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M27.2723 351.741C28.8108 350.821 30.0611 351.555 30.0661 353.387C30.071 355.215 28.8289 357.445 27.2904 358.367C25.7552 359.285 24.505 358.546 24.5 356.718C24.4951 354.886 25.7371 352.66 27.2723 351.741Z",
    fill: "url(#paint36_linear_437_4322)"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M27.2723 336.628C28.8108 335.708 30.0611 336.442 30.0661 338.274C30.071 340.102 28.8289 342.332 27.2904 343.254C25.7552 344.172 24.505 343.433 24.5 341.605C24.4951 339.773 25.7371 337.547 27.2723 336.628Z",
    fill: "url(#paint37_linear_437_4322)"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M27.2723 321.515C28.8108 320.595 30.0611 321.329 30.0661 323.161C30.071 324.989 28.8289 327.219 27.2904 328.141C25.7552 329.059 24.505 328.32 24.5 326.492C24.4951 324.66 25.7371 322.434 27.2723 321.515Z",
    fill: "url(#paint38_linear_437_4322)"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M27.2723 306.402C28.8108 305.482 30.0611 306.216 30.0661 308.048C30.071 309.876 28.8289 312.105 27.2904 313.027C25.7552 313.946 24.505 313.206 24.5 311.378C24.4951 309.546 25.7371 307.32 27.2723 306.402Z",
    fill: "url(#paint39_linear_437_4322)"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "M27.2723 291.289C28.8108 290.369 30.0611 291.103 30.0661 292.935C30.071 294.763 28.8289 296.992 27.2904 297.914C25.7552 298.833 24.505 298.093 24.5 296.265C24.4951 294.433 25.7371 292.207 27.2723 291.289Z",
    fill: "url(#paint40_linear_437_4322)"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "M38.4333 501.463C40.1267 502.477 40.1349 504.124 38.4531 505.138C36.7712 506.152 34.0236 506.152 32.3303 505.138C30.6369 504.126 30.6287 502.477 32.3105 501.463C33.9923 500.449 36.74 500.449 38.4333 501.463Z",
    fill: "#C1E2F5"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    d: "M28.0758 507.697C29.7692 508.711 29.7889 510.354 28.0956 511.373C26.4137 512.387 23.6777 512.38 21.9843 511.366C20.291 510.354 20.2712 508.71 21.9547 507.697C23.6464 506.678 26.3824 506.685 28.0758 507.697Z",
    fill: "#C1E2F5"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    d: "M59.1265 488.996C60.8199 490.01 60.838 491.652 59.1562 492.664C57.4727 493.678 54.7284 493.678 53.0334 492.664C51.34 491.652 51.3318 490.003 53.0136 488.989C54.6971 487.976 57.4348 487.983 59.1265 488.996Z",
    fill: "#C1E2F5"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    d: "M48.7838 495.225C50.4772 496.239 50.4854 497.887 48.8036 498.901C47.1218 499.915 44.3758 499.915 42.6825 498.901C40.9891 497.888 40.9792 496.239 42.6627 495.225C44.3429 494.213 47.0905 494.213 48.7838 495.225Z",
    fill: "#C1E2F5"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    d: "M69.4899 482.759C71.1832 483.773 71.1914 485.421 69.5096 486.435C67.8278 487.449 65.0918 487.442 63.3984 486.428C61.705 485.416 61.6853 483.772 63.3687 482.759C65.0489 481.747 67.7965 481.747 69.4899 482.759Z",
    fill: "#C1E2F5"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    d: "M90.195 470.287C91.8884 471.301 91.8966 472.949 90.2148 473.963C88.533 474.975 85.787 474.975 84.092 473.963C82.3986 472.951 82.3904 471.301 84.0722 470.287C85.7541 469.273 88.5017 469.273 90.195 470.287Z",
    fill: "#C1E2F5"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    d: "M79.8424 476.524C81.5358 477.538 81.544 479.185 79.8622 480.199C78.1804 481.213 75.4344 481.213 73.7411 480.199C72.0477 479.187 72.0378 477.538 73.7213 476.524C75.4015 475.511 78.1491 475.511 79.8424 476.524Z",
    fill: "#C1E2F5"
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    d: "M110.892 457.82C112.586 458.834 112.594 460.482 110.912 461.496C109.23 462.51 106.494 462.503 104.801 461.489C103.107 460.477 103.088 458.834 104.771 457.82C106.453 456.808 109.2 456.808 110.892 457.82Z",
    fill: "#C1E2F5"
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    d: "M100.535 464.056C102.229 465.07 102.247 466.712 100.565 467.725C98.8718 468.744 96.1374 468.739 94.444 467.725C92.7506 466.712 92.7309 465.069 94.4242 464.049C96.1061 463.039 98.8438 463.044 100.535 464.056Z",
    fill: "#C1E2F5"
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    d: "M17.7302 535.052C19.4235 536.064 19.4318 537.713 17.7499 538.727C16.0681 539.741 13.3205 539.741 11.6272 538.727C9.9338 537.715 9.92557 536.066 11.6074 535.052C13.2909 534.04 16.0368 534.04 17.7302 535.052Z",
    fill: "#C1E2F5"
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    d: "M7.37267 541.288C9.06603 542.302 9.08579 543.945 7.39243 544.964C5.7106 545.978 2.97456 545.971 1.28121 544.957C-0.412148 543.945 -0.431923 542.301 1.25155 541.288C2.94326 540.269 5.68097 540.276 7.37267 541.288Z",
    fill: "#C1E2F5"
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    d: "M38.4263 522.587C40.1196 523.601 40.1378 525.243 38.4559 526.255C36.7741 527.269 34.0282 527.269 32.3348 526.255C30.6415 525.243 30.6316 523.594 32.3151 522.58C33.9969 521.567 36.7329 521.574 38.4263 522.587Z",
    fill: "#C1E2F5"
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    d: "M28.0807 528.816C29.774 529.83 29.7823 531.478 28.1005 532.492C26.4187 533.506 23.6727 533.506 21.9794 532.492C20.286 531.479 20.2761 529.83 21.9596 528.816C23.6414 527.804 26.389 527.804 28.0807 528.816Z",
    fill: "#C1E2F5"
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    d: "M48.7828 516.351C50.4762 517.365 50.4844 519.012 48.8026 520.026C47.1208 521.04 44.3847 521.033 42.6914 520.019C40.998 519.007 40.9782 517.365 42.6617 516.351C44.3435 515.337 47.0895 515.337 48.7828 516.351Z",
    fill: "#C1E2F5"
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    d: "M69.4908 503.878C71.1842 504.892 71.1925 506.54 69.5106 507.554C67.8288 508.568 65.0829 508.568 63.3895 507.554C61.6962 506.541 61.6862 504.892 63.3697 503.878C65.0515 502.864 67.7975 502.864 69.4908 503.878Z",
    fill: "#C1E2F5"
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    d: "M59.1348 510.114C60.8281 511.128 60.8364 512.776 59.1545 513.79C57.4727 514.804 54.7268 514.804 53.0334 513.79C51.34 512.777 51.3318 511.128 53.0136 510.114C54.6955 509.1 57.4414 509.1 59.1348 510.114Z",
    fill: "#C1E2F5"
  })), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    d: "M90.1891 491.411C91.8824 492.425 91.8907 494.073 90.2088 495.087C88.527 496.101 85.791 496.094 84.0976 495.08C82.4043 494.067 82.3845 492.423 84.068 491.411C85.7498 490.399 88.4957 490.399 90.1891 491.411Z",
    fill: "#C1E2F5"
  })), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    d: "M79.8362 497.647C81.5296 498.661 81.5477 500.304 79.8659 501.316C78.1726 502.335 75.4381 502.33 73.7448 501.316C72.0514 500.304 72.0317 498.661 73.725 497.641C75.4069 496.628 78.1429 496.635 79.8362 497.647Z",
    fill: "#C1E2F5"
  })), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    d: "M318.025 560.948C319.728 561.967 319.728 563.611 318.045 564.623C316.363 565.637 313.637 565.636 311.932 564.616C310.239 563.604 310.23 561.967 311.912 560.955C313.596 559.942 316.332 559.935 318.025 560.948Z",
    fill: "#C1E2F5"
  })), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    d: "M307.615 554.719C309.308 555.731 309.307 557.375 307.625 558.387C305.943 559.401 303.217 559.401 301.523 558.387C299.83 557.373 299.81 555.731 301.494 554.719C303.176 553.706 305.922 553.705 307.615 554.719Z",
    fill: "#C1E2F5"
  })), _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    d: "M297.193 548.482C298.887 549.494 298.895 551.144 297.213 552.158C295.531 553.172 292.795 553.165 291.102 552.151C289.408 551.137 289.389 549.494 291.07 548.482C292.752 547.47 295.5 547.47 297.193 548.482Z",
    fill: "#C1E2F5"
  })), _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    d: "M286.769 542.246C288.463 543.26 288.473 544.909 286.791 545.921C285.109 546.935 282.373 546.929 280.678 545.914C278.985 544.902 278.976 543.265 280.658 542.253C282.34 541.239 285.076 541.232 286.769 542.246Z",
    fill: "#C1E2F5"
  })), _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    d: "M276.357 536.017C278.05 537.029 278.049 538.673 276.367 539.685C274.685 540.699 271.959 540.698 270.265 539.685C268.562 538.666 268.552 537.031 270.236 536.017C271.918 535.003 274.654 534.997 276.357 536.017Z",
    fill: "#C1E2F5"
  })), _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    d: "M328.447 567.184C330.14 568.196 330.149 569.845 328.467 570.859C326.785 571.873 324.049 571.866 322.356 570.852C320.662 569.838 320.643 568.196 322.324 567.184C324.008 566.171 326.754 566.171 328.447 567.184Z",
    fill: "#C1E2F5"
  })), _path76 || (_path76 = /*#__PURE__*/React.createElement("path", {
    d: "M338.869 573.42C340.562 574.432 340.571 576.081 338.889 577.095C337.207 578.109 334.471 578.103 332.777 577.089C331.084 576.074 331.064 574.432 332.746 573.42C334.428 572.408 337.174 572.408 338.869 573.42Z",
    fill: "#C1E2F5"
  })), _path77 || (_path77 = /*#__PURE__*/React.createElement("path", {
    d: "M359.703 585.887C361.396 586.901 361.406 588.55 359.724 589.562C358.043 590.576 355.307 590.57 353.612 589.556C351.918 588.543 351.91 586.906 353.592 585.894C355.274 584.88 358.011 584.873 359.703 585.887Z",
    fill: "#C1E2F5"
  })), _path78 || (_path78 = /*#__PURE__*/React.createElement("path", {
    d: "M349.296 579.656C350.99 580.668 350.986 582.312 349.304 583.325C347.623 584.339 344.896 584.339 343.203 583.325C341.51 582.311 341.49 580.668 343.173 579.656C344.855 578.644 347.603 578.644 349.296 579.656Z",
    fill: "#C1E2F5"
  })), _path79 || (_path79 = /*#__PURE__*/React.createElement("path", {
    d: "M284.937 111.472C314.596 93.7266 338.693 99.5308 338.761 124.429C338.787 134.136 335.142 145.324 328.935 156.402L337.328 174.613L319.366 170.834C310.097 182.852 298.183 193.872 285.183 201.649C255.524 219.395 231.427 213.59 231.36 188.694C231.294 163.792 255.279 129.218 284.937 111.472Z",
    fill: "#FE9BA8"
  })), _path80 || (_path80 = /*#__PURE__*/React.createElement("path", {
    d: "M318.089 143.904L318.107 150.954L252.082 190.46L252.062 183.408L318.089 143.904Z",
    fill: "#FE7386"
  })), _path81 || (_path81 = /*#__PURE__*/React.createElement("path", {
    d: "M318.065 133.596L318.083 140.647L252.057 180.153L252.039 173.103L318.065 133.596Z",
    fill: "#FE7386"
  })), _path82 || (_path82 = /*#__PURE__*/React.createElement("path", {
    d: "M318.032 123.289L318.052 130.327L252.026 169.833L252.008 162.795L318.032 123.289Z",
    fill: "#FE7386"
  })), _path83 || (_path83 = /*#__PURE__*/React.createElement("path", {
    d: "M225.178 52.8753C254.836 35.1298 278.932 40.9203 279.001 65.8324C279.069 90.7308 255.084 125.305 225.425 143.051C212.427 150.828 200.489 154.082 191.184 153.176L173.303 178.39L181.559 150.231C175.324 146.586 171.628 139.802 171.602 130.095C171.533 105.183 195.52 70.6209 225.178 52.8753Z",
    fill: "url(#paint41_linear_437_4322)"
  })), _path84 || (_path84 = /*#__PURE__*/React.createElement("path", {
    d: "M258.333 85.6379L258.353 92.6883L192.327 132.195L192.309 125.144L258.333 85.6379Z",
    fill: "#776EC4"
  })), _path85 || (_path85 = /*#__PURE__*/React.createElement("path", {
    d: "M258.307 75.3308L258.327 82.3812L192.301 121.887L192.281 114.837L258.307 75.3308Z",
    fill: "#776EC4"
  })), _path86 || (_path86 = /*#__PURE__*/React.createElement("path", {
    d: "M258.276 65.0229L258.296 72.0614L192.27 111.568L192.25 104.529L258.276 65.0229Z",
    fill: "#776EC4"
  })), _path87 || (_path87 = /*#__PURE__*/React.createElement("path", {
    d: "M171.738 377.884L159.43 370.474L180.266 361.411L192.572 368.823L171.738 377.884Z",
    fill: "#8E86D4"
  })), _path88 || (_path88 = /*#__PURE__*/React.createElement("path", {
    d: "M127.242 375.726L139.549 383.138C145.494 386.718 149.178 394.332 149.208 405.153L136.902 397.741C136.872 386.921 133.187 379.308 127.242 375.726Z",
    fill: "#7468D4"
  })), _path89 || (_path89 = /*#__PURE__*/React.createElement("path", {
    d: "M147.15 349.684L134.844 342.272L151.547 317.105L163.853 324.518L147.15 349.684Z",
    fill: "#8E86D4"
  })), _path90 || (_path90 = /*#__PURE__*/React.createElement("path", {
    d: "M163.881 324.417L151.543 317.105L163.849 324.518L176.187 331.829L163.881 324.417Z",
    fill: "#7468D4"
  })), _path91 || (_path91 = /*#__PURE__*/React.createElement("path", {
    d: "M133.311 342.031C133.121 342.012 132.942 341.985 132.741 341.973C132.227 341.908 131.713 341.857 131.176 341.831C130.987 341.812 130.797 341.806 130.596 341.794C130.071 341.775 129.535 341.763 129.01 341.758C128.809 341.76 128.596 341.778 128.171 341.78C128.015 341.78 127.837 341.782 127.68 341.795C127.391 341.795 127.101 341.823 126.811 341.838C126.598 341.859 126.397 341.872 126.196 341.9C125.928 341.9 125.671 341.92 125.393 341.942C125.124 341.997 124.846 342.029 124.577 342.07C124.376 342.084 124.164 342.104 123.953 342.139C123.663 342.18 123.361 342.214 123.06 342.273C122.894 342.294 122.714 342.335 122.324 342.408C122.1 342.449 121.889 342.495 121.665 342.536C121.34 342.596 121.029 342.651 120.693 342.731C120.459 342.791 120.225 342.852 119.98 342.905C119.756 342.96 119.545 343.006 119.321 343.072C118.751 343.214 118.183 343.368 117.591 343.549C117.367 343.615 117.145 343.683 116.932 343.743C116.351 343.931 115.761 344.138 114.801 344.458L127.107 351.871C128.066 351.55 128.657 351.342 129.237 351.154C129.448 351.094 129.672 351.026 129.896 350.959C130.487 350.778 131.056 350.625 131.626 350.483C131.848 350.416 132.061 350.369 132.285 350.316C132.53 350.261 132.764 350.201 132.999 350.142C133.334 350.061 133.647 350.007 133.97 349.947C134.194 349.906 134.406 349.86 134.629 349.819C135.019 349.744 135.197 349.704 135.365 349.684C135.666 349.624 135.969 349.59 136.259 349.549C136.472 349.515 136.683 349.495 136.884 349.481C137.152 349.44 137.43 349.406 137.699 349.351C137.979 349.331 138.234 349.31 138.503 349.308C138.704 349.281 138.905 349.267 139.117 349.247C139.407 349.233 139.697 349.206 139.987 349.204C140.143 349.191 140.321 349.191 140.478 349.189C140.903 349.187 141.115 349.167 141.316 349.167C141.84 349.172 142.377 349.184 142.903 349.203C143.104 349.215 143.293 349.221 143.482 349.24C144.019 349.266 144.533 349.317 145.047 349.382C145.248 349.394 145.428 349.421 145.617 349.44C146.143 349.498 146.645 349.583 147.148 349.681L134.841 342.268C134.337 342.174 133.835 342.089 133.311 342.031Z",
    fill: "#7468D4"
  })), _path92 || (_path92 = /*#__PURE__*/React.createElement("path", {
    d: "M90.3173 359.674C90.1048 359.867 89.8939 360.062 89.6716 360.26C89.0934 360.779 88.502 361.318 87.9337 361.858C87.7228 362.05 87.4988 362.264 87.288 362.47C87.0442 362.697 86.7988 362.936 86.5533 363.162C86.2305 363.476 85.9191 363.795 85.5946 364.121C85.3838 364.341 85.1614 364.555 84.715 365.007C84.5486 365.173 84.3691 365.347 84.2027 365.526C83.9029 365.825 83.6015 366.151 83.3132 366.458C83.1122 366.672 82.9014 366.904 82.6889 367.136C82.4204 367.416 82.1437 367.689 81.8867 367.974C81.6083 368.275 81.3514 368.573 81.0845 368.893C80.8737 369.113 80.6727 369.338 80.4602 369.572C80.1818 369.898 79.8919 370.217 79.5921 370.571C79.4373 370.743 79.2594 370.957 78.892 371.402C78.6812 371.648 78.4687 371.882 78.2793 372.114C77.9778 372.481 77.6665 372.839 77.3667 373.205C77.1443 373.471 76.922 373.749 76.6996 374.043C76.5102 374.289 76.3108 374.529 76.1099 374.782C75.5877 375.441 75.0754 376.107 74.5631 376.759C74.3638 377.037 74.1727 377.285 73.9849 377.544C73.4726 378.21 72.9719 378.895 72.1367 380.033L84.4432 387.446C85.2784 386.307 85.7791 385.622 86.2898 384.958C86.4792 384.699 86.6686 384.453 86.8679 384.173C87.3786 383.521 87.8925 382.855 88.4147 382.198C88.6157 381.945 88.815 381.705 89.0044 381.459C89.2268 381.165 89.4508 380.887 89.6716 380.621C89.973 380.255 90.2843 379.895 90.5841 379.53C90.7735 379.297 90.9844 379.064 91.1969 378.818C91.5642 378.372 91.7421 378.159 91.8986 377.985C92.1984 377.633 92.4883 377.312 92.765 376.988C92.9775 376.754 93.1768 376.529 93.3893 376.308C93.6578 375.989 93.9131 375.69 94.1899 375.39C94.4468 375.103 94.7252 374.832 94.9921 374.552C95.2029 374.32 95.4138 374.086 95.6148 373.872C95.903 373.567 96.2044 373.241 96.5042 372.94C96.6723 372.761 96.8502 372.587 97.0165 372.421C97.4629 371.969 97.6853 371.755 97.8962 371.535C98.219 371.209 98.532 370.89 98.8548 370.576C99.1003 370.349 99.3441 370.11 99.5895 369.883C99.8004 369.676 100.024 369.463 100.235 369.27C100.804 368.73 101.395 368.191 101.973 367.672C102.195 367.472 102.406 367.279 102.619 367.086C103.21 366.574 103.788 366.081 104.368 365.576L92.0617 358.163C91.4868 358.669 90.907 359.162 90.3173 359.674Z",
    fill: "#7468D4"
  })), _path93 || (_path93 = /*#__PURE__*/React.createElement("path", {
    d: "M55.2103 411.222C55.1 411.514 54.9781 411.827 54.8677 412.118C54.5564 412.916 54.2566 413.706 53.9798 414.498C53.8695 414.79 53.7575 415.096 53.6471 415.415C53.3819 416.185 53.1035 416.963 52.8498 417.754C52.7493 418.066 52.639 418.385 52.4397 419.01C52.3507 419.249 52.2848 419.488 52.1975 419.741C52.0756 420.159 51.9537 420.565 51.8088 420.997C51.7314 421.296 51.6325 421.608 51.5436 421.9C51.4332 422.286 51.3113 422.665 51.2009 423.049C51.0906 423.435 50.9917 423.812 50.8797 424.212C50.8023 424.51 50.715 424.816 50.6475 425.096C50.5272 425.528 50.4152 425.939 50.3048 426.351C50.2389 426.617 50.1945 426.856 50.0512 427.394C49.9737 427.706 49.8963 428.019 49.8189 428.331C49.7201 428.763 49.6097 429.214 49.5208 429.652C49.4433 429.99 49.3659 430.316 49.3 430.648C49.2341 430.939 49.1781 431.238 49.1122 431.544C48.9574 432.314 48.7927 433.09 48.6494 433.869C48.595 434.168 48.5407 434.453 48.4847 434.751C48.3529 435.521 48.2211 436.305 48.0234 437.568L60.3299 444.981C60.5275 443.719 60.6594 442.935 60.7912 442.164C60.8472 441.865 60.9015 441.58 60.9558 441.28C61.0991 440.503 61.2639 439.726 61.4187 438.954C61.4846 438.649 61.5406 438.35 61.6065 438.058C61.6708 437.727 61.7482 437.401 61.8273 437.061C61.9162 436.623 62.0266 436.172 62.1254 435.74C62.2028 435.428 62.2802 435.115 62.3577 434.803C62.501 434.265 62.5454 434.026 62.6113 433.76C62.7217 433.348 62.8337 432.935 62.954 432.505C63.0198 432.225 63.1088 431.921 63.1862 431.621C63.2966 431.221 63.3971 430.842 63.5074 430.458C63.6178 430.072 63.7397 429.693 63.8501 429.309C63.939 429.017 64.0378 428.705 64.1152 428.406C64.2585 427.974 64.3805 427.57 64.5024 427.15C64.5897 426.897 64.6572 426.658 64.7461 426.419C64.9454 425.794 65.0558 425.475 65.1563 425.163C65.41 424.372 65.6883 423.594 65.9535 422.824C66.0655 422.505 66.176 422.199 66.2863 421.907C66.5631 421.117 66.8629 420.325 67.1742 419.527C67.2845 419.235 67.4064 418.923 67.5168 418.631C67.8396 417.827 68.1608 417.023 68.482 416.245L56.1756 408.832C55.8544 409.614 55.5332 410.418 55.2103 411.222Z",
    fill: "#7468D4"
  })), _path94 || (_path94 = /*#__PURE__*/React.createElement("path", {
    d: "M39.5956 460.355L27.2891 452.944L48.0278 437.57L60.3342 444.982L39.5956 460.355Z",
    fill: "#8E86D4"
  })), _path95 || (_path95 = /*#__PURE__*/React.createElement("path", {
    d: "M39.6236 470.725L27.3171 463.314L27.2891 452.945L39.5956 460.355L39.6236 470.725Z",
    fill: "#7468D4"
  })), _path96 || (_path96 = /*#__PURE__*/React.createElement("path", {
    d: "M107.167 339.061L94.8594 331.649L112.262 321.235L124.571 328.647L107.167 339.061Z",
    fill: "#8E86D4"
  })), _path97 || (_path97 = /*#__PURE__*/React.createElement("path", {
    d: "M104.369 365.574L92.0625 358.163L94.8595 331.648L107.168 339.061L104.369 365.574Z",
    fill: "#8E86D4"
  })), _path98 || (_path98 = /*#__PURE__*/React.createElement("path", {
    d: "M68.4833 416.248L56.1769 408.836L43.4141 396.5L55.7206 403.911L68.4833 416.248Z",
    fill: "#7468D4"
  })), _path99 || (_path99 = /*#__PURE__*/React.createElement("path", {
    d: "M55.7206 403.911L43.4141 396.5L55.6695 374.471L67.9776 381.884L55.7206 403.911Z",
    fill: "#8E86D4"
  })), _path100 || (_path100 = /*#__PURE__*/React.createElement("path", {
    d: "M124.57 328.647L127.114 351.873C128.072 351.552 128.664 351.344 129.243 351.156C129.456 351.096 129.678 351.029 129.902 350.961C130.494 350.78 131.062 350.627 131.632 350.485C131.854 350.418 132.067 350.37 132.291 350.318C132.536 350.263 132.772 350.203 133.006 350.143C133.34 350.063 133.653 350.009 133.976 349.949C134.2 349.908 134.411 349.862 134.635 349.821C135.025 349.746 135.203 349.706 135.371 349.686C135.673 349.626 135.974 349.592 136.264 349.551C136.476 349.517 136.687 349.496 136.888 349.483C137.157 349.442 137.435 349.408 137.704 349.355C137.982 349.334 138.239 349.314 138.507 349.312C138.708 349.285 138.909 349.271 139.122 349.251C139.412 349.237 139.702 349.21 139.993 349.208C140.15 349.194 140.328 349.194 140.484 349.193C140.909 349.191 141.122 349.17 141.323 349.17C141.848 349.175 142.383 349.187 142.909 349.206C143.11 349.218 143.299 349.225 143.489 349.244C144.024 349.269 144.538 349.321 145.052 349.385C145.253 349.397 145.432 349.425 145.622 349.444C146.147 349.502 146.65 349.587 147.152 349.684L163.855 324.516L176.193 331.828L163.348 359.089C163.875 359.758 164.199 360.174 164.514 360.598C164.637 360.75 164.749 360.909 164.861 361.081C165.174 361.492 165.478 361.935 165.759 362.392C165.871 362.551 165.983 362.723 166.095 362.909C166.207 363.095 166.331 363.287 166.454 363.466C166.622 363.751 166.757 364.016 166.904 364.287C167.016 364.473 167.117 364.664 167.219 364.857C167.41 365.181 167.499 365.328 167.566 365.487C167.701 365.752 167.836 366.004 167.958 366.276C168.059 366.469 168.138 366.673 168.228 366.86C168.352 367.105 168.464 367.343 168.576 367.595C168.688 367.86 168.79 368.119 168.902 368.384C168.991 368.57 169.07 368.775 169.149 368.968C169.261 369.246 169.375 369.538 169.487 369.816C169.554 369.989 169.622 370.175 169.678 370.34C169.825 370.772 169.904 370.991 169.983 371.209C170.095 371.515 170.197 371.839 170.297 372.138C170.376 372.409 170.444 372.662 170.511 372.901C170.579 373.126 170.658 373.331 170.714 373.552C170.884 374.142 171.03 374.733 171.177 375.335C171.245 375.561 171.289 375.786 171.347 376.018C171.482 376.628 171.618 377.253 171.742 377.882L192.576 368.821L192.604 379.19L149.214 405.152C149.155 383.379 134.29 374.586 116.006 385.527C97.7236 396.466 82.9545 422.99 83.0154 444.762L39.6257 470.724L39.5977 460.355L60.3363 444.981C60.534 443.719 60.6658 442.936 60.7975 442.164C60.8519 441.865 60.9079 441.58 60.9623 441.282C61.1056 440.505 61.2703 439.728 61.4251 438.956C61.491 438.651 61.547 438.352 61.6129 438.06C61.6788 437.729 61.7562 437.403 61.8336 437.063C61.9226 436.625 62.033 436.174 62.1318 435.742C62.2092 435.43 62.2866 435.117 62.364 434.805C62.5074 434.267 62.5518 434.028 62.6177 433.762C62.7281 433.35 62.8384 432.937 62.9603 432.507C63.0262 432.227 63.1152 431.923 63.1926 431.623C63.303 431.223 63.4034 430.844 63.5138 430.46C63.6242 430.074 63.7461 429.695 63.8564 429.311C63.9454 429.019 64.0459 428.707 64.1217 428.408C64.265 427.976 64.3869 427.572 64.5087 427.152C64.5977 426.899 64.6636 426.66 64.7526 426.421C64.9519 425.796 65.0622 425.477 65.1627 425.165C65.418 424.374 65.6948 423.596 65.96 422.826C66.072 422.507 66.1823 422.201 66.2927 421.909C66.5694 421.119 66.8692 420.327 67.1806 419.529C67.2909 419.237 67.4128 418.925 67.5248 418.633C67.846 417.829 68.1689 417.025 68.4901 416.247L55.7257 403.911L67.9828 381.882L84.4469 387.444C85.282 386.305 85.7828 385.621 86.2934 384.957C86.4828 384.697 86.6723 384.451 86.8716 384.171C87.3839 383.519 87.8962 382.854 88.4184 382.195C88.6193 381.942 88.8186 381.701 89.0081 381.455C89.2305 381.162 89.4545 380.884 89.6752 380.617C89.9766 380.252 90.2879 379.892 90.5877 379.526C90.7772 379.294 90.988 379.06 91.1989 378.815C91.5662 378.369 91.7441 378.156 91.9006 377.983C92.2004 377.63 92.4903 377.311 92.7687 376.985C92.9812 376.751 93.1805 376.525 93.393 376.305C93.6598 375.986 93.9168 375.687 94.1952 375.387C94.4505 375.1 94.7289 374.828 94.9974 374.548C95.2082 374.316 95.4207 374.082 95.62 373.869C95.9099 373.563 96.2098 373.237 96.5112 372.937C96.6792 372.758 96.8571 372.584 97.0235 372.418C97.4699 371.966 97.6923 371.752 97.9031 371.532C98.226 371.206 98.5373 370.887 98.8618 370.573C99.1056 370.345 99.3527 370.106 99.5965 369.881C99.8073 369.675 100.031 369.461 100.242 369.268C100.81 368.729 101.4 368.189 101.98 367.67C102.202 367.471 102.413 367.278 102.626 367.085C103.215 366.573 103.795 366.079 104.373 365.574L107.17 339.059L124.57 328.647Z",
    fill: "url(#paint42_linear_437_4322)"
  })), _path101 || (_path101 = /*#__PURE__*/React.createElement("path", {
    d: "M67.98 381.884L55.6719 374.471L72.136 380.033L84.4425 387.446L67.98 381.884Z",
    fill: "#7468D4"
  })), _path102 || (_path102 = /*#__PURE__*/React.createElement("path", {
    d: "M553.032 121.644L407.219 34.3977C403.048 31.9019 399.268 31.6714 396.537 33.3154L380.559 42.9384C383.29 41.2945 387.07 41.5249 391.241 44.0207L537.056 131.267C545.344 136.226 552.049 148.259 552.021 158.13L551.197 459.452C551.184 464.355 549.512 467.807 546.815 469.431L562.794 459.808C565.49 458.184 567.162 454.732 567.175 449.829L567.999 148.507C568.025 138.638 561.321 126.605 553.032 121.644Z",
    fill: "#A4D4ED"
  })), _path103 || (_path103 = /*#__PURE__*/React.createElement("path", {
    d: "M537.056 131.268C545.344 136.227 552.049 148.261 552.021 158.132L551.195 459.452C551.169 469.323 544.42 473.307 536.131 468.348L390.317 381.102C382.028 376.143 375.324 364.11 375.352 354.239L376.175 52.9181C376.202 43.0476 382.95 39.0614 391.239 44.0223L537.056 131.268Z",
    fill: "#C1E2F5"
  })), _path104 || (_path104 = /*#__PURE__*/React.createElement("path", {
    d: "M537.014 141.444C540.565 143.57 543.44 148.73 543.43 152.949L542.639 442.147L383.953 347.199L384.744 58.0002C384.755 53.7836 387.65 52.073 391.201 54.1984L537.014 141.444Z",
    fill: "url(#paint43_linear_437_4322)"
  })), _path105 || (_path105 = /*#__PURE__*/React.createElement("path", {
    d: "M476.65 412.587C479.024 414.007 480.938 417.443 480.93 420.269C480.922 423.084 478.996 424.222 476.622 422.802L443.92 403.235C441.556 401.82 439.642 398.385 439.648 395.57C439.657 392.743 441.582 391.606 443.946 393.02L476.65 412.587Z",
    fill: "#7468D4"
  })), _path106 || (_path106 = /*#__PURE__*/React.createElement("path", {
    d: "M495.028 423.224C497.392 424.639 499.306 428.074 499.3 430.901C499.292 433.716 497.366 434.854 495.002 433.439C492.628 432.019 490.714 428.582 490.723 425.767C490.729 422.94 492.655 421.803 495.028 423.224Z",
    fill: "#7468D4"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_437_4322",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 383,
    y: 53,
    width: 161,
    height: 390
  }, _path107 || (_path107 = /*#__PURE__*/React.createElement("path", {
    d: "M537.006 141.444C540.558 143.569 543.432 148.73 543.422 152.948L542.632 442.147L383.945 347.198L384.736 57.9999C384.747 53.7833 387.642 52.0728 391.193 54.1982L537.006 141.444Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_437_4322)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M475.2 308.157L459.395 298.638C465.61 294.92 471.831 294.02 476.58 296.837L492.385 306.356C487.635 303.539 481.413 304.438 475.2 308.157Z",
    fill: "#5E54B3"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask1_437_4322",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 383,
    y: 53,
    width: 161,
    height: 390
  }, _path108 || (_path108 = /*#__PURE__*/React.createElement("path", {
    d: "M537.006 141.444C540.558 143.569 543.432 148.73 543.422 152.948L542.632 442.147L383.945 347.198L384.736 57.9999C384.747 53.7833 387.642 52.0728 391.193 54.1982L537.006 141.444Z",
    fill: "white"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_437_4322)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M475.195 308.157C481.41 304.439 487.632 303.539 492.381 306.356C501.9 311.977 501.95 330.279 492.493 347.255C487.774 355.726 481.568 362.274 475.353 365.992L475.195 308.157Z",
    fill: "#776EC4"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask2_437_4322",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 383,
    y: 53,
    width: 161,
    height: 390
  }, _path109 || (_path109 = /*#__PURE__*/React.createElement("path", {
    d: "M537.006 141.444C540.558 143.569 543.432 148.73 543.422 152.948L542.632 442.147L383.945 347.198L384.736 57.9999C384.747 53.7833 387.642 52.0728 391.193 54.1982L537.006 141.444Z",
    fill: "white"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask2_437_4322)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M475.356 365.993L459.549 356.474L459.391 298.638L475.197 308.157L475.356 365.993Z",
    fill: "#4E4694"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask3_437_4322",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 383,
    y: 53,
    width: 161,
    height: 390
  }, _path110 || (_path110 = /*#__PURE__*/React.createElement("path", {
    d: "M537.006 141.444C540.558 143.569 543.432 148.73 543.422 152.948L542.632 442.147L383.945 347.198L384.736 57.9999C384.747 53.7833 387.642 52.0728 391.193 54.1982L537.006 141.444Z",
    fill: "white"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask3_437_4322)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M475.145 288.922L459.338 279.404L459.242 244.235L475.047 253.754L475.145 288.922Z",
    fill: "#4E4694"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask4_437_4322",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 383,
    y: 53,
    width: 161,
    height: 390
  }, _path111 || (_path111 = /*#__PURE__*/React.createElement("path", {
    d: "M537.006 141.444C540.558 143.569 543.432 148.73 543.422 152.948L542.632 442.147L383.945 347.198L384.736 57.9999C384.747 53.7833 387.642 52.0728 391.193 54.1982L537.006 141.444Z",
    fill: "white"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask4_437_4322)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M475.047 253.754L459.242 244.235C482.476 230.344 505.747 226.964 523.493 237.444L539.298 246.963C521.554 236.481 498.282 239.863 475.047 253.754Z",
    fill: "#5E54B3"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask5_437_4322",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 383,
    y: 53,
    width: 161,
    height: 390
  }, _path112 || (_path112 = /*#__PURE__*/React.createElement("path", {
    d: "M537.006 141.444C540.558 143.569 543.432 148.73 543.422 152.948L542.632 442.147L383.945 347.198L384.736 57.9999C384.747 53.7833 387.642 52.0728 391.193 54.1982L537.006 141.444Z",
    fill: "white"
  }))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask5_437_4322)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M475.047 253.754C498.281 239.863 521.552 236.483 539.297 246.963L518.479 284.342C506.509 277.273 490.816 279.545 475.142 288.924L475.047 253.754Z",
    fill: "#776EC4"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask6_437_4322",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 383,
    y: 53,
    width: 161,
    height: 390
  }, _path113 || (_path113 = /*#__PURE__*/React.createElement("path", {
    d: "M537.006 141.444C540.558 143.569 543.432 148.73 543.422 152.948L542.632 442.147L383.945 347.198L384.736 57.9999C384.747 53.7833 387.642 52.0728 391.193 54.1982L537.006 141.444Z",
    fill: "white"
  }))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask6_437_4322)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M474.915 203.5L459.109 193.981C494.657 172.712 528.091 169.182 553.249 184.039L569.054 193.558C543.896 178.701 510.462 182.231 474.915 203.5Z",
    fill: "#5E54B3"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask7_437_4322",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 383,
    y: 53,
    width: 161,
    height: 390
  }, _path114 || (_path114 = /*#__PURE__*/React.createElement("path", {
    d: "M537.006 141.444C540.558 143.569 543.432 148.73 543.422 152.948L542.632 442.147L383.945 347.198L384.736 57.9999C384.747 53.7833 387.642 52.0728 391.193 54.1982L537.006 141.444Z",
    fill: "white"
  }))), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask7_437_4322)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M474.914 203.5C510.461 182.231 543.895 178.7 569.053 193.557L548.227 230.942C528.673 219.393 502.665 222.145 475.011 238.692L474.914 203.5Z",
    fill: "#776EC4"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask8_437_4322",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 383,
    y: 53,
    width: 161,
    height: 390
  }, _path115 || (_path115 = /*#__PURE__*/React.createElement("path", {
    d: "M537.006 141.444C540.558 143.569 543.432 148.73 543.422 152.948L542.632 442.147L383.945 347.198L384.736 57.9999C384.747 53.7833 387.642 52.0728 391.193 54.1982L537.006 141.444Z",
    fill: "white"
  }))), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask8_437_4322)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M475.01 238.692L459.205 229.173L459.109 193.981L474.915 203.5L475.01 238.692Z",
    fill: "#4E4694"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask9_437_4322",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 383,
    y: 53,
    width: 161,
    height: 390
  }, _path116 || (_path116 = /*#__PURE__*/React.createElement("path", {
    d: "M537.006 141.444C540.558 143.569 543.432 148.73 543.422 152.948L542.632 442.147L383.945 347.198L384.736 57.9999C384.747 53.7833 387.642 52.0728 391.193 54.1982L537.006 141.444Z",
    fill: "white"
  }))), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask9_437_4322)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M474.774 153.268L458.969 143.749C505.798 115.728 549.852 111.071 582.996 130.645L598.801 140.164C565.658 120.59 521.605 125.249 474.774 153.268Z",
    fill: "#5E54B3"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask10_437_4322",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 383,
    y: 53,
    width: 161,
    height: 390
  }, _path117 || (_path117 = /*#__PURE__*/React.createElement("path", {
    d: "M537.006 141.444C540.558 143.569 543.432 148.73 543.422 152.948L542.632 442.147L383.945 347.198L384.736 57.9999C384.747 53.7833 387.642 52.0728 391.193 54.1982L537.006 141.444Z",
    fill: "white"
  }))), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask10_437_4322)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M474.773 153.268C521.603 125.247 565.656 120.59 598.8 140.164L577.973 177.548C550.431 161.271 513.813 165.146 474.869 188.448L474.773 153.268Z",
    fill: "#776EC4"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask11_437_4322",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 383,
    y: 53,
    width: 161,
    height: 390
  }, _path118 || (_path118 = /*#__PURE__*/React.createElement("path", {
    d: "M537.006 141.444C540.558 143.569 543.432 148.73 543.422 152.948L542.632 442.147L383.945 347.198L384.736 57.9999C384.747 53.7833 387.642 52.0728 391.193 54.1982L537.006 141.444Z",
    fill: "white"
  }))), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask11_437_4322)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M474.871 188.45L459.066 178.931L458.969 143.749L474.774 153.267L474.871 188.45Z",
    fill: "#4E4694"
  }))), _path119 || (_path119 = /*#__PURE__*/React.createElement("path", {
    d: "M475.227 307.92L475.385 365.894C469.157 369.62 462.92 370.51 458.158 367.698C448.616 362.063 448.566 343.706 458.046 326.701C462.777 318.2 468.997 311.646 475.227 307.92Z",
    fill: "#FE9BA8"
  })), _path120 || (_path120 = /*#__PURE__*/React.createElement("path", {
    d: "M458.161 367.698L442.318 358.155C432.776 352.52 432.727 334.163 442.206 317.158C446.937 308.657 453.157 302.103 459.387 298.377L475.23 307.918C469.002 311.644 462.78 318.198 458.049 326.7C448.57 343.708 448.621 362.063 458.161 367.698Z",
    fill: "#FE7386"
  })), _path121 || (_path121 = /*#__PURE__*/React.createElement("path", {
    d: "M410.847 323.546L395.004 314.004C412.677 282.282 435.946 257.778 459.234 243.844L475.078 253.385C451.789 267.321 428.52 291.825 410.847 323.546Z",
    fill: "#FE7386"
  })), _path122 || (_path122 = /*#__PURE__*/React.createElement("path", {
    d: "M475.084 253.387L475.179 288.641C459.468 298.042 443.778 314.564 431.855 335.962L410.852 323.547C428.526 291.825 451.795 267.321 475.084 253.387Z",
    fill: "#FE9BA8"
  })), _path123 || (_path123 = /*#__PURE__*/React.createElement("path", {
    d: "M380.828 305.818L364.984 296.275C390.037 251.303 423.463 214.789 459.094 193.469L474.937 203.01C439.304 224.332 405.88 260.846 380.828 305.818Z",
    fill: "#FE7386"
  })), _path124 || (_path124 = /*#__PURE__*/React.createElement("path", {
    d: "M474.944 203.011L475.041 238.289C447.323 254.874 421.322 283.27 401.848 318.229L380.836 305.818C405.887 260.845 439.311 224.332 474.944 203.011Z",
    fill: "#FE9BA8"
  })), _path125 || (_path125 = /*#__PURE__*/React.createElement("path", {
    d: "M350.816 288.102L334.973 278.559C367.98 219.31 412.02 171.205 458.962 143.118L474.805 152.66C427.863 180.748 383.823 228.853 350.816 288.102Z",
    fill: "#FE7386"
  })), _path126 || (_path126 = /*#__PURE__*/React.createElement("path", {
    d: "M474.804 152.662L474.901 187.928C435.863 211.286 399.257 251.267 371.829 300.502L350.816 288.103C383.822 228.852 427.862 180.747 474.804 152.662Z",
    fill: "#FE9BA8"
  })), _path127 || (_path127 = /*#__PURE__*/React.createElement("path", {
    d: "M231.57 374.196V233.544",
    stroke: "#C1E2F5",
    strokeWidth: 5.5856,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path128 || (_path128 = /*#__PURE__*/React.createElement("path", {
    d: "M203.238 391.517V250.865",
    stroke: "#C1E2F5",
    strokeWidth: 5.5856,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path129 || (_path129 = /*#__PURE__*/React.createElement("path", {
    d: "M231.572 242.615C236.406 242.615 240.324 238.554 240.324 233.545C240.324 228.536 236.406 224.475 231.572 224.475C226.739 224.475 222.82 228.536 222.82 233.545C222.82 238.554 226.739 242.615 231.572 242.615Z",
    fill: "#C1E2F5"
  })), _path130 || (_path130 = /*#__PURE__*/React.createElement("path", {
    d: "M203.238 259.933C208.071 259.933 211.988 255.873 211.988 250.865C211.988 245.857 208.071 241.797 203.238 241.797C198.406 241.797 194.488 245.857 194.488 250.865C194.488 255.873 198.406 259.933 203.238 259.933Z",
    fill: "#C1E2F5"
  })), _path131 || (_path131 = /*#__PURE__*/React.createElement("path", {
    d: "M380.921 413.995L268.609 481.636C261.447 485.95 249.794 485.955 242.586 481.643L129.53 413.996C125.904 411.827 124.096 408.979 124.102 406.137L124.012 439.448C124.004 442.292 125.814 445.139 129.439 447.309L242.496 514.956C249.704 519.269 261.356 519.264 268.519 514.95L380.83 447.309C384.39 445.165 386.174 442.358 386.182 439.549L386.273 406.236C386.264 409.044 384.48 411.85 380.921 413.995Z",
    fill: "#73B1D1"
  })), _path132 || (_path132 = /*#__PURE__*/React.createElement("path", {
    d: "M380.844 398.373C388.052 402.687 388.081 409.681 380.919 413.995L268.608 481.636C261.445 485.95 249.795 485.955 242.585 481.641L129.528 413.995C122.32 409.681 122.291 402.687 129.453 398.373L241.766 330.731C248.928 326.417 260.581 326.412 267.789 330.726L380.844 398.373Z",
    fill: "#A4D4ED"
  })), _path133 || (_path133 = /*#__PURE__*/React.createElement("path", {
    d: "M373.382 402.79C376.462 404.633 376.479 407.636 373.41 409.483L261.097 477.125C258.028 478.972 253.027 478.972 249.946 477.13L136.89 409.483C133.81 407.641 133.793 404.638 136.862 402.79L249.176 335.148C252.244 333.299 257.245 333.299 260.326 335.143L373.382 402.79Z",
    fill: "#C1E2F5"
  })), _path134 || (_path134 = /*#__PURE__*/React.createElement("path", {
    d: "M336.556 420.095C337.712 420.788 337.719 421.906 336.576 422.594C335.426 423.287 333.565 423.287 332.407 422.594C331.25 421.903 331.244 420.784 332.393 420.091C333.537 419.403 335.4 419.403 336.556 420.095Z",
    fill: "#FE7386"
  })), _path135 || (_path135 = /*#__PURE__*/React.createElement("path", {
    d: "M329.332 424.448C330.488 425.139 330.49 426.261 329.345 426.95C328.195 427.642 326.334 427.643 325.176 426.95C324.02 426.257 324.013 425.139 325.163 424.448C326.308 423.758 328.176 423.755 329.332 424.448Z",
    fill: "#FE7386"
  })), _path136 || (_path136 = /*#__PURE__*/React.createElement("path", {
    d: "M343.791 415.738C344.948 416.429 344.954 417.548 343.804 418.241C342.661 418.93 340.793 418.932 339.635 418.241C338.479 417.548 338.477 416.428 339.622 415.738C340.77 415.047 342.633 415.047 343.791 415.738Z",
    fill: "#FE7386"
  })), _path137 || (_path137 = /*#__PURE__*/React.createElement("path", {
    d: "M351.027 411.381C352.184 412.073 352.19 413.191 351.041 413.884C349.891 414.577 348.029 414.577 346.871 413.884C345.715 413.191 345.708 412.073 346.858 411.381C348.008 410.69 349.871 410.69 351.027 411.381Z",
    fill: "#FE7386"
  })), _path138 || (_path138 = /*#__PURE__*/React.createElement("path", {
    d: "M358.258 407.026C359.414 407.72 359.421 408.838 358.271 409.529C357.121 410.222 355.26 410.222 354.102 409.529C352.946 408.838 352.939 407.72 354.089 407.026C355.238 406.333 357.1 406.333 358.258 407.026Z",
    fill: "#FE7386"
  })), _path139 || (_path139 = /*#__PURE__*/React.createElement("path", {
    d: "M234.454 494.637C236.04 495.587 237.32 497.884 237.315 499.772C237.31 501.661 236.022 502.432 234.435 501.483C232.849 500.534 231.569 498.226 231.574 496.338C231.581 494.45 232.869 493.69 234.454 494.637Z",
    fill: "#FE7386"
  })), _path140 || (_path140 = /*#__PURE__*/React.createElement("path", {
    d: "M224.192 488.497C225.778 489.446 227.058 491.744 227.053 493.632C227.048 495.52 225.76 496.292 224.174 495.342C222.587 494.393 221.308 492.085 221.313 490.197C221.317 488.309 222.606 487.548 224.192 488.497Z",
    fill: "#FE7386"
  })), _path141 || (_path141 = /*#__PURE__*/React.createElement("path", {
    d: "M213.93 482.356C215.516 483.306 216.805 485.607 216.8 487.497C216.795 489.385 215.498 490.151 213.912 489.202C212.326 488.253 211.046 485.945 211.051 484.057C211.056 482.169 212.344 481.407 213.93 482.356Z",
    fill: "#FE7386"
  })), _path142 || (_path142 = /*#__PURE__*/React.createElement("path", {
    d: "M146.175 432.401L146.158 438.646L134.957 431.944L134.974 425.699L146.175 432.401Z",
    fill: "url(#paint44_linear_437_4322)"
  })), _path143 || (_path143 = /*#__PURE__*/React.createElement("path", {
    d: "M159.907 440.619L159.89 446.862L148.688 440.16L148.704 433.915L159.907 440.619Z",
    fill: "url(#paint45_linear_437_4322)"
  })), _path144 || (_path144 = /*#__PURE__*/React.createElement("path", {
    d: "M265.868 398.725C280.367 407.401 288.383 418.914 288.452 431.152L271.472 431.15C271.416 421.636 265.18 412.682 253.901 405.933C242.626 399.186 227.689 395.471 211.837 395.471L211.781 385.275C232.164 385.276 251.374 390.053 265.868 398.725Z",
    fill: "#EBF8FF"
  })), _path145 || (_path145 = /*#__PURE__*/React.createElement("path", {
    d: "M248.777 409.022C258.254 414.692 264.146 422.52 264.19 431.152H247.206C247.174 425.33 243.201 420.049 236.81 416.225C230.42 412.401 221.616 410.035 211.915 410.036L211.859 399.84C226.241 399.841 239.301 403.353 248.777 409.022Z",
    fill: "#EBF8FF"
  })), _path146 || (_path146 = /*#__PURE__*/React.createElement("path", {
    d: "M230.269 420.166C232.803 421.682 234.376 423.777 234.387 426.092C234.417 430.72 228.187 434.47 220.478 434.469C216.624 434.47 213.13 433.533 210.595 432.015C208.061 430.499 206.488 428.405 206.477 426.09C206.447 421.462 212.677 417.711 220.386 417.713C224.24 417.713 227.736 418.65 230.269 420.166Z",
    fill: "#EBF8FF"
  })), _path147 || (_path147 = /*#__PURE__*/React.createElement("path", {
    d: "M282.962 388.431C302.062 399.859 312.631 415.031 312.718 431.152H295.733C295.661 417.756 286.875 405.146 270.99 395.642C255.114 386.142 234.074 380.908 211.759 380.908L211.703 370.711C238.558 370.711 263.868 377.007 282.962 388.431Z",
    fill: "#EBF8FF"
  })), _path148 || (_path148 = /*#__PURE__*/React.createElement("path", {
    d: "M481.863 489.338C481.835 479.546 478.489 472.65 473.098 469.403L438.269 448.426C443.66 451.672 447.007 458.569 447.034 468.361L447.047 473.459C447.101 493.171 433.683 517.258 417.13 527.161L374.325 552.773C365.995 557.757 358.435 558.214 352.977 554.924L387.804 575.902C393.265 579.189 400.824 578.734 409.154 573.751L451.957 548.139C468.512 538.234 481.929 514.148 481.876 494.436L481.863 489.338Z",
    fill: "url(#paint46_linear_437_4322)"
  })), _path149 || (_path149 = /*#__PURE__*/React.createElement("path", {
    d: "M451.721 461.811C472.786 449.207 489.975 459.358 490.044 484.444L490.058 489.542C490.127 514.628 473.05 545.281 451.985 557.885L409.18 583.497C388.114 596.102 370.926 585.95 370.857 560.864L370.844 555.766C370.775 530.68 387.852 500.027 408.918 487.423L451.721 461.811ZM481.876 494.436L481.861 489.339C481.807 469.625 468.301 461.649 451.748 471.554L408.944 497.166C392.391 507.07 378.973 531.156 379.026 550.87L379.041 555.967C379.095 575.681 392.601 583.657 409.154 573.752L451.957 548.14C468.512 538.236 481.93 514.15 481.876 494.436Z",
    fill: "#776EC4"
  })), _path150 || (_path150 = /*#__PURE__*/React.createElement("path", {
    d: "M444.063 438.096C437.113 433.91 427.495 434.491 416.893 440.834L374.09 466.446C353.024 479.05 335.947 509.703 336.016 534.789L336.031 539.887C336.065 552.349 340.323 561.125 347.184 565.256L382.013 586.233C375.152 582.102 370.894 573.326 370.86 560.862L370.847 555.765C370.777 530.678 387.854 500.025 408.921 487.422L451.724 461.81C462.326 455.468 471.944 454.886 478.894 459.071L444.063 438.096Z",
    fill: "url(#paint47_linear_437_4322)"
  })), _path151 || (_path151 = /*#__PURE__*/React.createElement("path", {
    d: "M460.209 461.118L414.731 488.509C411.83 490.255 407.112 490.257 404.193 488.511L358.413 461.118C356.946 460.241 356.213 459.087 356.216 457.936L356.18 471.424C356.176 472.575 356.909 473.729 358.377 474.608L404.157 502C407.076 503.747 411.795 503.745 414.694 501.999L460.173 474.608C461.614 473.739 462.336 472.604 462.339 471.465L462.375 457.975C462.372 459.114 461.65 460.249 460.209 461.118Z",
    fill: "#FE7386"
  })), _path152 || (_path152 = /*#__PURE__*/React.createElement("path", {
    d: "M460.177 454.793C463.096 456.539 463.107 459.371 460.208 461.118L414.73 488.509C411.83 490.255 407.111 490.257 404.192 488.51L358.412 461.118C355.493 459.371 355.482 456.539 358.381 454.793L403.859 427.402C406.759 425.656 411.478 425.654 414.397 427.4L460.177 454.793Z",
    fill: "#FE9BA8"
  })), _path153 || (_path153 = /*#__PURE__*/React.createElement("path", {
    d: "M457.162 456.58C458.409 457.326 458.416 458.542 457.173 459.291L411.695 486.682C410.453 487.43 408.427 487.43 407.18 486.684L361.4 459.291C360.153 458.545 360.147 457.33 361.389 456.58L406.867 429.189C408.109 428.442 410.135 428.442 411.382 429.188L457.162 456.58Z",
    fill: "#5E54B3"
  })), _path154 || (_path154 = /*#__PURE__*/React.createElement("path", {
    d: "M424.43 455.412L424.448 459.061C417.505 459.061 411.873 462.452 411.897 466.621H405.817C405.782 460.441 414.133 455.41 424.43 455.412Z",
    fill: "#FE7386"
  })), _path155 || (_path155 = /*#__PURE__*/React.createElement("path", {
    d: "M424.987 462.689C425.894 463.231 426.458 463.981 426.461 464.809C426.471 466.466 424.24 467.808 421.481 467.808C420.101 467.808 418.851 467.474 417.943 466.931C417.035 466.388 416.472 465.638 416.469 464.809C416.459 463.153 418.689 461.809 421.448 461.809C422.827 461.809 424.079 462.146 424.987 462.689Z",
    fill: "#FE7386"
  })), _path156 || (_path156 = /*#__PURE__*/React.createElement("path", {
    d: "M424.406 450.196L424.424 453.846C418.751 453.846 413.417 455.175 409.406 457.591C405.394 460.007 403.196 463.213 403.215 466.62H397.133C397.11 462.238 399.935 458.117 405.092 455.01C410.248 451.906 417.107 450.196 424.406 450.196Z",
    fill: "#FE7386"
  })), _path157 || (_path157 = /*#__PURE__*/React.createElement("path", {
    d: "M424.377 444.982L424.396 448.632C416.407 448.632 408.894 450.505 403.246 453.907C397.598 457.31 394.502 461.825 394.527 466.622H388.446C388.414 460.85 392.139 455.418 398.932 451.326C405.725 447.236 414.762 444.982 424.377 444.982Z",
    fill: "#FE7386"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_437_4322",
    x1: 306.18,
    y1: 339.388,
    x2: 348.004,
    y2: 320.141,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FE7386"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7468D4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_437_4322",
    x1: 306.18,
    y1: 322.42,
    x2: 348.004,
    y2: 303.173,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FE7386"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7468D4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_437_4322",
    x1: 306.18,
    y1: 305.452,
    x2: 348.004,
    y2: 286.205,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FE7386"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7468D4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_437_4322",
    x1: 306.18,
    y1: 288.484,
    x2: 348.004,
    y2: 269.236,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FE7386"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7468D4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_437_4322",
    x1: 306.18,
    y1: 271.516,
    x2: 348.004,
    y2: 252.269,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FE7386"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7468D4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_437_4322",
    x1: 306.18,
    y1: 254.548,
    x2: 348.004,
    y2: 235.301,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FE7386"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7468D4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_437_4322",
    x1: 306.18,
    y1: 237.58,
    x2: 348.004,
    y2: 218.333,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FE7386"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7468D4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_437_4322",
    x1: 306.18,
    y1: 220.612,
    x2: 348.004,
    y2: 201.365,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FE7386"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7468D4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_437_4322",
    x1: 306.18,
    y1: 203.644,
    x2: 348.004,
    y2: 184.397,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FE7386"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7468D4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_437_4322",
    x1: 306.18,
    y1: 186.677,
    x2: 348.004,
    y2: 167.43,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FE7386"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7468D4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_437_4322",
    x1: 306.18,
    y1: 169.709,
    x2: 348.004,
    y2: 150.461,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FE7386"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7468D4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_437_4322",
    x1: 306.18,
    y1: 152.741,
    x2: 348.004,
    y2: 133.493,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FE7386"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7468D4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint12_linear_437_4322",
    x1: 306.18,
    y1: 135.773,
    x2: 348.004,
    y2: 116.525,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FE7386"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7468D4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint13_linear_437_4322",
    x1: 306.18,
    y1: 118.805,
    x2: 348.004,
    y2: 99.5574,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FE7386"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7468D4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint14_linear_437_4322",
    x1: 306.18,
    y1: 101.837,
    x2: 348.004,
    y2: 82.5893,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FE7386"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7468D4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint15_linear_437_4322",
    x1: 306.18,
    y1: 84.8689,
    x2: 348.004,
    y2: 65.6217,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FE7386"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7468D4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint16_linear_437_4322",
    x1: 285.74,
    y1: 263.032,
    x2: 327.564,
    y2: 243.785,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FE7386"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7468D4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint17_linear_437_4322",
    x1: 285.74,
    y1: 246.065,
    x2: 327.564,
    y2: 226.817,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FE7386"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7468D4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint18_linear_437_4322",
    x1: 285.74,
    y1: 229.096,
    x2: 327.564,
    y2: 209.849,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FE7386"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7468D4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint19_linear_437_4322",
    x1: 285.74,
    y1: 212.129,
    x2: 327.564,
    y2: 192.881,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FE7386"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7468D4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint20_linear_437_4322",
    x1: 285.74,
    y1: 195.161,
    x2: 327.564,
    y2: 175.913,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FE7386"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7468D4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint21_linear_437_4322",
    x1: 285.74,
    y1: 178.193,
    x2: 327.564,
    y2: 158.946,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FE7386"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7468D4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint22_linear_437_4322",
    x1: 285.74,
    y1: 161.225,
    x2: 327.564,
    y2: 141.978,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FE7386"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7468D4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint23_linear_437_4322",
    x1: 285.74,
    y1: 144.257,
    x2: 327.564,
    y2: 125.01,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FE7386"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7468D4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint24_linear_437_4322",
    x1: 285.74,
    y1: 127.289,
    x2: 327.564,
    y2: 108.042,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FE7386"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7468D4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint25_linear_437_4322",
    x1: 285.74,
    y1: 110.321,
    x2: 327.564,
    y2: 91.0739,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FE7386"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7468D4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint26_linear_437_4322",
    x1: 285.74,
    y1: 93.3529,
    x2: 327.564,
    y2: 74.1055,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FE7386"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7468D4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint27_linear_437_4322",
    x1: 285.74,
    y1: 76.3853,
    x2: 327.564,
    y2: 57.1379,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FE7386"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7468D4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint28_linear_437_4322",
    x1: 285.74,
    y1: 59.4176,
    x2: 327.564,
    y2: 40.1702,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FE7386"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7468D4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint29_linear_437_4322",
    x1: 285.74,
    y1: 42.4492,
    x2: 327.564,
    y2: 23.2018,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FE7386"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7468D4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint30_linear_437_4322",
    x1: 285.74,
    y1: 25.4816,
    x2: 327.564,
    y2: 6.23417,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FE7386"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7468D4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint31_linear_437_4322",
    x1: 285.74,
    y1: 8.51349,
    x2: 327.564,
    y2: -10.7339,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FE7386"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7468D4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint32_linear_437_4322",
    x1: 19.4448,
    y1: 419.38,
    x2: 56.697,
    y2: 402.237,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FE7386"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7468D4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint33_linear_437_4322",
    x1: 19.4448,
    y1: 404.266,
    x2: 56.6972,
    y2: 387.123,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FE7386"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7468D4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint34_linear_437_4322",
    x1: 19.4448,
    y1: 389.153,
    x2: 56.6969,
    y2: 372.01,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FE7386"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7468D4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint35_linear_437_4322",
    x1: 19.4448,
    y1: 374.041,
    x2: 56.6969,
    y2: 356.897,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FE7386"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7468D4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint36_linear_437_4322",
    x1: 19.4448,
    y1: 358.927,
    x2: 56.6971,
    y2: 341.784,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FE7386"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7468D4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint37_linear_437_4322",
    x1: 19.4448,
    y1: 343.814,
    x2: 56.6969,
    y2: 326.671,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FE7386"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7468D4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint38_linear_437_4322",
    x1: 19.4448,
    y1: 328.701,
    x2: 56.697,
    y2: 311.558,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FE7386"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7468D4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint39_linear_437_4322",
    x1: 19.4448,
    y1: 313.588,
    x2: 56.6972,
    y2: 296.445,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FE7386"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7468D4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint40_linear_437_4322",
    x1: 19.4448,
    y1: 298.475,
    x2: 56.697,
    y2: 281.332,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FE7386"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7468D4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint41_linear_437_4322",
    x1: 150.714,
    y1: 151.709,
    x2: 366.405,
    y2: 6.99778,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7468D4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint42_linear_437_4322",
    x1: 39.5942,
    y1: 397.621,
    x2: 192.601,
    y2: 397.621,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7468D4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint43_linear_437_4322",
    x1: 379.932,
    y1: 361.697,
    x2: 635.368,
    y2: 41.7126,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7468D4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint44_linear_437_4322",
    x1: 136.445,
    y1: 433.58,
    x2: 194.672,
    y2: 415.065,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7468D4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint45_linear_437_4322",
    x1: 140.146,
    y1: 445.222,
    x2: 198.372,
    y2: 426.707,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7468D4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint46_linear_437_4322",
    x1: 352.976,
    y1: 513.217,
    x2: 481.876,
    y2: 513.217,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7468D4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint47_linear_437_4322",
    x1: 336.016,
    y1: 510.827,
    x2: 478.891,
    y2: 510.827,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7468D4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIoTbanner2);
export default __webpack_public_path__ + "static/media/IOTbanner2.787663d42aca0a117a317675b6eaf5dd.svg";
export { ForwardRef as ReactComponent };